import { render, staticRenderFns } from "./GameFinishingMap.vue?vue&type=template&id=28240dd8"
import script from "./GameFinishingMap.vue?vue&type=script&lang=js"
export * from "./GameFinishingMap.vue?vue&type=script&lang=js"
import "./GameFinishingMap.vue?vue&type=style&index=0&id=28240dd8&prod&lang=css"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports